import React from 'react';
import Link from 'next/link';
import config from '../../../config';
import styles from './getInTouch.module.scss';

const GetInTouch = () => {
    return (
        <div className={styles.getInTouch}>
            <div className="container">
                <div className="row">
                    <div className="col p0">
                        <div className={styles.content}>
                            <p>Questions on Flex Leagues?</p>
                            <div className={styles.ctaWrapper}>
                                <a href={`https://support.${config.siteBaseUrl}/en/support/tickets/new`} target="_blank" rel="noopener noreferrer" className="btn btn-xl btn-white text-gray">
                                    GET IN TOUCH
                                </a>
                            </div>
                            <small>
                                For technical issues, please <a href={`https://support.${config.siteBaseUrl}/`} target="_blank" rel="noopener noreferrer" className="text-white fixed-underline">contact support.</a>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetInTouch;
